import { useEffect } from "react";
import AuthService from "../../../../services/auth_service";

const ValidSession = (vm) => {
    useEffect(() => {
        let cancelled = false;

        const validateSession = async () => {
            if (vm.redirecting) return;

            vm.setLoading(true);
            try {
                if (!vm.code || !vm.resetToken) {
                    if (!cancelled) vm.setActive(false);
                    return;
                }

                const session = await AuthService.getSession(vm.code, vm.resetToken);
                if (vm.logout(session)) return;
                if (!cancelled) {
                    vm.setActive(!!session?.Active);
                }
            } catch (e) {
                if (!cancelled && !vm.redirecting) {
                    vm.setActive(false);
                    vm.message("No se pudo validar el enlace. Intenta generar uno nuevo", "error");
                }
            } finally {
                if (!cancelled) vm.setLoading(false);
            }
        };

        validateSession();

        return () => {
            cancelled = true;
        };
    }, [vm.code, vm.resetToken, vm.redirecting]); 
};

export default ValidSession;
